export const TEAM_DATA_LOADING = "TEAM_DATA_LOADING";
export const TEAM_DATA = "TEAM_DATA";
export const SET_USER_DATA = "SET_USER_DATA";
export const MEMBERSHIP_DATA_LOADING = "MEMBERSHIP_DATA_LOADING";
export const MEMBERSHIP_DATA = "MEMBERSHIP_DATA";
